import { defineComponent as _defineComponent } from 'vue'
import ChipButton from '@/ui-components/ChipButton.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'ToggleButton',
  props: {
    active: { type: Boolean, default: false },
    negative: { type: Boolean, default: false },
    icon: { default: '' },
    noBorders: { type: Boolean, default: false },
    disabled: { type: Boolean, default: false }
  },
  setup(__props: any) {

const props = __props as { active: boolean, negative: boolean, icon: string, noBorders: boolean, disabled: boolean };



return { __sfc: true,props, ChipButton }
}

})